import { Box } from "@mui/material";
import BAScreenHeader from "../config/components/BAScreenHeader";
import BAButton from "../config/components/BAButton";
import { useNavigate } from "react-router-dom";
import { Delete, Get } from "../config/apimethods/apimethods";
import { useEffect, useState } from "react";
import BAGrid from "../config/components/BAGrid";
import BAShowError from "../config/components/BAShowerror";
import BAIconbutton from "../config/components/BAIconbutton";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function Product() {
    const [productsList, setProductsList] = useState([])
    const [showMessage, setShowMessae] = useState(false)
    const [message, setMessage] = useState('')
    const [loader, setLoader] = useState(false)

    const navigate = useNavigate()


    const getProducts = () => {
        setLoader(true)
        Get('product').then(res => {
            setLoader(false)
            setProductsList([...res.data])
        }).catch(err => {
            setLoader(false)
            console.log(err)
            setMessage(err.message)
            setShowMessae(true)
        })
    }
    const addEditForm = (id) => {
        navigate(`/productform/${id ? id : ''}`)
    }
    const inventory = () => {
        navigate(`/productinventory`)
    }

    const delProduct = (id) => {
        Delete('product', id).then((res) => {
            setShowMessae(true)
            setMessage(res.message)
            getProducts()
        }).catch(err => {
            setShowMessae(true)
            setMessage(err.message)
        })
    }

    useEffect(() => {
        getProducts()
    }, [])
    return <>
        <BAShowError message={message} open={showMessage} close={(e) => setShowMessae(e)} />
        <Box>
            <BAScreenHeader title="Product" buttonsList={[
                {
                    displayField: <BAButton onClick={() => inventory()} label='Inventory' />
                },
                {
                    displayField: <BAButton onClick={() => addEditForm()} label='Add Product' />
                },
            ]} />
            <BAGrid datasource={productsList} gridCols={[
                {
                    key: 'edit',
                    label: 'Edit',
                    className: 'btnCell',
                    displayField: (e) => <BAIconbutton onClick={() => addEditForm(e._id)} icon={<EditIcon />} />
                },
                {
                    key: 'delete',
                    label: 'Delete',
                    className: 'btnCell',
                    displayField: (e) => <BAIconbutton onClick={() => delProduct(e._id)} icon={<DeleteIcon color="error" />} />
                },
                {
                    key: 'image',
                    label: 'Image',
                    displayField: (e) => <img width={50} height={50} className="rounded shadow" src={e.image_url ? e.image_url : 'https://png.pngtree.com/png-vector/20190820/ourmid/pngtree-no-image-vector-illustration-isolated-png-image_1694547.jpg'} />
                },
                {
                    key: 'code',
                    label: 'Code'
                },
                {
                    key: 'name',
                    label: 'Name'
                },
                {
                    key: 'category',
                    label: 'Category'
                },
                {
                    key: 'price',
                    label: 'Price'
                },
            ]} loading={loader} />
        </Box>
    </>
}